"use client"; // useLingui requires client component

import { useLingui } from "@lingui/react/macro";
import { FileQuestionIcon } from "lucide-react";

import ErrorPage from "./_components/error-page";

export default function NotFound() {
  const { t } = useLingui();
  return <ErrorPage code="404" title={t`Not Found`} icon={FileQuestionIcon} />;
}
